import { Survey } from '../entities/Survey';

export const isSelfAssessmentSurvey = (survey: Survey) => {
  return survey.relationship === 'candidate';
};
